import { NgbDateParserFormatter, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import {Injectable} from "@angular/core";
import {DateTime} from "luxon";
import {DateUtils} from "./date-utils";

/**
 * FORMATEO de fechas para NgbDatePicker
 * Usa momentjs para parseo y formateo
 */
@Injectable()
export class NgbLuxonDateFormatter extends NgbDateParserFormatter {

    readonly DT_FORMAT = DateUtils.DATETIME_DEFAULT_FORMAT;

    parse(value: string): NgbDateStruct {
        if (value) {
            value = value.trim();
            let mdt = DateTime.fromFormat(value, this.DT_FORMAT)
        }
        return null;
    }
    format(date: NgbDateStruct): string {
        if (!date) return '';
        let mdt = DateTime.fromObject({ year:date.year, month:date.month, day:date.day, hour: 0, minute: 0, second:0, millisecond:0 });
        if (!mdt.isValid) return '';
        return mdt.toFormat(this.DT_FORMAT);
    }
}
